import React from 'react';
import { CheckboxField, Label } from 'jbc-front/components/Form';
import InlineBlock from './InlineBlock';

const reformatMemomapping = memoColorMappings =>
  memoColorMappings.map(mapping => ({
    value: mapping.value,
    label: <span style={{ color: mapping.label }}>●</span>
  }));

const MemoColorsSection = ({ memoColorMappings }) => {
  const formatedMemoColors = reformatMemomapping(memoColorMappings);

  return (
    <tr>
      <th>
        <Label text="メモの色" />
      </th>
      <td>
        <InlineBlock>
          {formatedMemoColors.map(item => (
            <CheckboxField key={item.value} name={`memoColorIds["${item.value}"]`} label={item.label} width={10} />
          ))}
        </InlineBlock>
        <div>
          <InlineBlock>
            <CheckboxField name="noMemo" label="メモ無し" width={10} normalize={value => !!value} />
          </InlineBlock>
        </div>
      </td>
    </tr>
  );
};

export default MemoColorsSection;
